import React from 'react';

const base = "w-full border rounded-md px-3 py-2.5 text-sm text-gray-900 bg-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors";
const errorCls = "border-red-400 focus:ring-red-400 focus:border-red-400";
const normalCls = "border-gray-300";

export function Field({ label, hint, error, required, children }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
      {hint && !error && <p className="mt-1 text-xs text-gray-400">{hint}</p>}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

export function Input({ error, ...props }) {
  return <input {...props} className={`${base} ${error ? errorCls : normalCls}`} />;
}

export function Textarea({ error, rows = 3, ...props }) {
  return <textarea rows={rows} {...props} className={`${base} ${error ? errorCls : normalCls} resize-none`} />;
}

export function Select({ error, children, ...props }) {
  return (
    <select {...props} className={`${base} ${error ? errorCls : normalCls}`}>
      {children}
    </select>
  );
}

export function FileInput({ label, hint, error, onChange, accept = 'image/*', preview, multiple = false }) {
  return (
    <Field label={label} hint={hint} error={error}>
      <div className={`border-2 border-dashed rounded-md p-4 text-center cursor-pointer hover:border-yellow-500 transition-colors ${error ? 'border-red-400' : 'border-gray-300'}`}>
        <input type="file" accept={accept} multiple={multiple} onChange={onChange} className="hidden" id={`file-${label}`} />
        <label htmlFor={`file-${label}`} className="cursor-pointer">
          {preview ? (
            <img src={preview} alt="preview" className="h-20 object-contain mx-auto mb-2 rounded" />
          ) : (
            <div className="text-gray-400 text-xs">Click to upload {multiple ? 'images (up to 5)' : 'image'}</div>
          )}
          <span className="text-xs text-yellow-600 font-medium">Browse file{multiple ? 's' : ''}</span>
        </label>
      </div>
    </Field>
  );
}

export function FormActions({ onCancel, loading, submitLabel = 'Save Changes' }) {
  return (
    <div className="flex justify-end gap-3 pt-4 border-t border-gray-100 mt-4">
      <button type="button" onClick={onCancel}
        className="px-5 py-2 text-sm font-medium text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
        Cancel
      </button>
      <button type="submit" disabled={loading}
        className="px-5 py-2 text-sm font-medium text-white bg-yellow-600 rounded-md hover:bg-yellow-700 disabled:opacity-50 transition-colors">
        {loading ? 'Saving...' : submitLabel}
      </button>
    </div>
  );
}
